import React, { useState, useEffect } from 'react';
import { DataProviderInstance } from '../../api/DataProvider';
import styles from './Company.module.css';
import RegistrationData from './areas/registrationData/RegistrationData';
import Loading from '../../components/loading/Loading';

function Company() {
  const [loading, setLoading] = useState(true);
  
  const dataProvider = DataProviderInstance();
  
  useEffect(() => {
    setLoading(true);
    if (dataProvider && dataProvider.GetCompany) {
      dataProvider.GetCompany(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <div className='page-content'>
      <div className={styles.mainContainer}>
        {loading ? (
          <div className={styles.loadingContainer}>
            <Loading size={40} />
            <p>Carregando dados da empresa...</p>
          </div>
        ) : (
          <RegistrationData />
        )}
      </div>
    </div>
  );
}

export default Company;
